import React from "react";
import PropTypes from "prop-types";

const DynamicIconGroup = ({ icons }) => {
  if (!icons || icons.length === 0) return null;

  // Filter out icons without a valid image source
  const validIcons = icons.filter(
    (icon) =>
      icon.image &&
      icon.image !== "" &&
      icon.image !== "fiducia/icons/noun-image-5229947-D3D3D3.svg"
  );

  const calculatePosition = (index, total) => {
    const offset = (total - 1) / 2;
    return `${50 + (index - offset) * 8}%`;
  };

  return (
    <div style={styles.container}>
      {console.log("Icons received:", icons)}

      {validIcons.map((icon, index) => (
        <div
          key={index}
          className="dynamic-icon"
          onClick={icon.onClick}
          style={{
            ...styles.icon,
            bottom: calculatePosition(index, validIcons.length),
          }}
        >
          <img
            src={icon.image}
            alt={icon.alt || "icon"}
            style={{
              width: icon.width || "30px",
              height: icon.height || "30px",
              borderRadius: "25%",
            }}
          />
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    top: "50%",
    left: "20px",
    transform: "translateY(-50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1000,
  },
  icon: {
    cursor: "pointer",
    borderRadius: "30px",
    marginBottom: "20px",
  },
};

DynamicIconGroup.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      alt: PropTypes.string,
      width: PropTypes.string,
      height: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

DynamicIconGroup.defaultProps = {
  icons: [],
};

export default DynamicIconGroup;
